export default "__VITE_ASSET__C4goM7U2__"